import Model from './Model'

export default class CustomerUserModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'customerUsers'
  }
}
